export enum IFsVariableTypeEnum {
  Input = "input",
  Number = "number",
  FreeText = "editor-basic",
  Image = "image",
  Video = "video",
  Media = "media",
  Ai = "ai",
  Select = "select",
  Multiselect = "multiselect",
  Date = "date",
  Color = "color",
  Iframe = "iframe",
  Data = "data",
  Table = "table",
  Calculated = "calc",
  List = "list",
  ImageVideo = "image-video",
}

export interface IFsAccountVariable {
  _id: string;
  plan: string;
  variable: {
    type: string;
    name: string;
    title: string;
    default: string;
    tip: string;
    validation: unknown;
  };
}

/** One embedded row of a "list" variable's `children[]` — a mini
 * variable-data object per sub-variable (no separate document, no
 * `parentId` cross-reference). */
export interface IFsVariableChildData {
  type: string;
  /** Slug key, unique within the parent's `children[]`. */
  name: string;
  /** Display name. */
  title: string;
  /** Fallback value (scalar sub-types only). */
  default?: unknown;
  /** select / multiselect sub-types. */
  options?: Array<{ label: string; value: string }>;
}

export interface IFsVariableData {
  type: IFsVariableTypeEnum;
  name: string;
  title: string;
  default: unknown;
  tip: string;
  validation: {
    required?: boolean;
    regex?: string;
    max?: number;
    errorMessage?: string;
  };
  mapping?: string;
  customMapping?: boolean | null;
  parentId?: string | null;
  required?: boolean;
  packages?: string[];
  mappingsObject?: Record<string, string>;
  options?: Array<{ label: string; value: string }>;
  prompt?: string;
  /** Optional freeform description shown alongside profile custom fields. */
  description?: string;
  /** "list" — embedded sub-variable definitions (see `IFsVariableChildData`). */
  children?: IFsVariableChildData[];
}

export interface IFsVariable {
  _id: string;
  orgId: string;
  plan?: "trial" | "paid";
  variable: IFsVariableData;
  createdAt: string;
  updatedAt: string;
  archived?: boolean;
}
